<!--乡级待审核 -->
<template>
  <div style="width: 100%">
    <div class="searchcontent" style="padding:0px">
    </div>
    
    <div class="searchtable">
      <el-table
        ref="table"
        :data="systemlist"
        border
        stripe
        v-loading="showDataLoading"
        :header-row-style="{height:'30px'}"
        :header-cell-style="{padding:'5px'}"
        :row-style="{height:'30px'}"
        :cell-style="{padding:'5px'}"
         :height="tableHeight"
      >
      
        <el-table-column prop="settingID" label="编号" width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        
        <el-table-column prop="policyMeasureName" label="政策措施" min-width="200">
        </el-table-column>
        
        <el-table-column prop="currentProgressName" label="当前进度" width="180">
        </el-table-column>
        <el-table-column
                    prop="waitAuditNum"
                    label="数量(个)"
                    width="150">
        </el-table-column>
        <el-table-column label="操作"  width="200">
           <template slot-scope="scope"> <!-- -->
            <el-button type="text" size="mini"  v-if="permission.isHaveLookPermission" @click="lookDetail(scope.row)" title="查看详情" >查看详情</el-button>
            
          </template>
        </el-table-column>
      </el-table>

      <div class="pageblock">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
 <!--详情-->
       <el-dialog  
            :title="particularstitle"
            :show-close="true"
            :close-on-click-modal="false"
            custom-class="dialog_wrap"
            :visible.sync="dialogdetailVisible"
            class="eldialog detaildialog"
            v-loading="showDataDetailLoading"
            :modal-append-to-body="true"
             append-to-body
            :style="'margin-top:0px;left:' + initLeft()"
            >
            <div class="searchcontent">
                <el-form :inline="true"  class="demo-form-inline">
                            <el-form-item>
                                <el-input size="small" v-model.trim="detailsearchForm.keywords" placeholder="请输入申请人姓名" ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input size="small" v-model.trim="certificateNo" placeholder="请输入申请人证件号"   maxlength="18"  onkeyup="this.value=this.value.replace(/[^\X0-9]/g, '')"></el-input>
                            </el-form-item>
                            <el-form-item v-if="region_level == 5">
                            <el-select size="small" v-model="detailsearchForm.villageID" style="width:200px"  placeholder="请选择村级行政区划"  >
                                    <el-option
                                    v-for="item in villageList"
                                    :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID"
                                    >
                                </el-option>
                            </el-select>
                            </el-form-item> 
                            <el-form-item>
                                <el-button size="small" plain type="primary" icon="el-icon-search" @click="ondetailsearchForm">查询</el-button>
                            </el-form-item>
                           <!-- <el-form-item> @click="onbatchchecked"
                                <el-button size="small" plain type="primary" icon="el-icon-search" v-if="permission.isHaveCheckPermission" @click="oncheckList">审核</el-button>
                            </el-form-item> -->
                </el-form>
           </div>
        <div class="searchtable" >
            <el-table
                ref="table"
                :data="applyaudituserlist"
                 border
                stripe
                v-loading="showDataLoading"
                :header-row-style="{height:'30px'}"
                :header-cell-style="{padding:'5px'}"
                :row-style="{height:'30px'}"
                :cell-style="{padding:'5px'}"
            
                >
          
                <el-table-column prop="" label="编号" width="60">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
                </el-table-column>
                <el-table-column
                    prop="applyType"
                    label="申请来源"
                    width="90"
                    >
                     <template slot-scope="scope">
                    <span v-if="scope.row.applyType == 1">个人申请</span>
                    <span v-if="scope.row.applyType == 2">窗口受理</span> 
                </template> 
                </el-table-column>
                <el-table-column
                    prop="realName"
                    label="申请人姓名"
                    width="100"
                    >
                </el-table-column>
             
                 <el-table-column
                    prop=""
                    label="性别"
                    width="60" 
                   >
                    <template slot-scope="scope">
                    <span v-if="scope.row.sexID == 1">男</span>
                    <span v-if="scope.row.sexID == 2">女</span> 
                </template>   
                </el-table-column>
                 <el-table-column
                    prop="userBirthday"
                    label="出生年月"
                    width="100"
                   >
                </el-table-column>
                 <el-table-column
                    prop="certificateNo"
                    label="身份证号"
                    width="165"
                   >
                </el-table-column>
                 <el-table-column
                    prop="maritalStatus"
                    label="婚姻状况"
                    width="85"
                   >
                   <!-- 1初婚；2再婚；3离婚；4丧偶 -->
                    <template slot-scope="scope">
                    <span v-if="scope.row.maritalStatus == 1">初婚</span>
                    <span v-if="scope.row.maritalStatus == 2">再婚</span> 
                    <span v-if="scope.row.maritalStatus == 3">离婚</span>
                    <span v-if="scope.row.maritalStatus == 4">丧偶</span>
                </template>  
                </el-table-column>
                 <el-table-column
                    prop="marriageChanges"
                    label="婚姻变动年月"
                    width="110"
                   >
                </el-table-column>
                  <!-- <el-table-column
                    prop="WorkUnit"
                    label="工作单位"
                    width="150"
                   >
                </el-table-column> -->
                  <el-table-column
                    prop="enjoyCensusAddress"
                    label="户籍地"
                    min-width="180"
                   >
                </el-table-column>
                  <el-table-column
                    prop="surviveChildrenNum"
                    label="现子女数"
                    width="85"
                   >
                </el-table-column>
                  <el-table-column
                    prop="contactTel"
                    label="联系电话"
                    width="120"
                   >
                </el-table-column>
                  <el-table-column
                    prop="applyTime"
                    label="申请时间"
                    width="100"
                   >
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="160" >
                    <template slot-scope="scope">
                        <el-button  type="text" size="mini"  @click="editFunds(scope.row)"  >查看资料</el-button>
                   
                        <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini"  class="tablecolumn"  v-if="permission.isHaveCheckPermission" @click="checked(scope.row,scope.$index)" :disabled='region_level != 5'>审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pageblock">
            <el-pagination
            @size-change="handledatailSizeChange"
            @current-change="handledatailCurrentChange"
            :current-page="page"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="datailtotalCount"
            >
            </el-pagination>
             </div>
        </div>
       </el-dialog>
       <!-- 审核 -->
           <el-dialog title="审核" :visible.sync="dialogFormVisible" :show-close="true"  custom-class="dialog_wrap"    @close="clearEditList('checkedForm')"   style="margin-top:0px;left: 0px;z-index: 2154;"  class="logindialog" width="600px">
            <el-form ref="checkedForm" :rules="rules" label-width="130px" :model="checkedForm">
                 <el-form-item label="是否通过" >
                <el-radio v-model="checkedForm.is_audit_pass" label="0">否</el-radio>
                <el-radio v-model="checkedForm.is_audit_pass" label="1">是</el-radio>
                </el-form-item>
                 <el-form-item label="不通过原因：" prop="people_logout_reason_id" v-if="checkedForm.is_audit_pass==`0`">
                        <el-select size="medium" v-model="checkedForm.noPassReason" placeholder="请选择不通过原因" >
                            <el-option
                            v-for="item in checkedForm.noPassReasonList"
                            :key="item.systemCodeID"
                            :label="item.systemCodeName"
                            :value="item.systemCodeID">
                            </el-option>
                        </el-select>
                </el-form-item>   
               <el-form-item label="不通过原因：" prop="noPassReasontext"  class="textarea" v-if="checkedForm.is_audit_pass==`0`">
                        <el-input
                            type="textarea"
                            maxlength="1000"
                            :rows="4"
                            placeholder="请输入不通过原因(最多可录入1000字)"
                            v-model.trim="checkedForm.noPassReasontext">
                            </el-input>
                    </el-form-item>   
            </el-form>
            
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="medium" type="primary" :loading="loading" :disabled="disabled" @click="oncheckSubmit">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 查看资料 -->  
        <el-dialog title="查看资料" :show-close="true"
          :close-on-click-modal="false"
          custom-class="dialog_wrap"
          :visible.sync="dialogdataFormVisible"
          class="eldialog"
      
          :modal-append-to-body="true"
          append-to-body
          :style="'margin-top:0px;left:' + initLeft()"
           @close="clearlookoverList()"
          >
            <!-- <Particulars :valueID="applyRecordID"  :indexID="keyindex" :markID="mark" ></Particulars> -->
             <Particulars :valueID="applyRecordID"  :indexID="keyindex" :markID="mark" :markshow="markshowID"  :markauditStatus="markauditStatusID" :markuser="markuserID" :markpolicyMeasure="markpolicyMeasureID" :markrewardRecord="markrewardRecordID" :filterShowdata="dialogdataFormVisible" @getStatedata="getTypedata"></Particulars>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogdataFormVisible = false">取 消</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import { systemcodeModule } from "@/request/systemmange.js";
import { regionModule } from "@/request/systemmange.js";
import { applyauditModel } from "@/request/applyauditmanage.js";
import store from '@/store'
import { sysframe } from '@/tools/sysframe.js'
import { permissionTool } from "@/tools/permissiontool.js";
import $ from 'jquery'
import {baseconfig} from '@/config.js'
import {publicFun} from '@/tools/time.js'
import Particulars from "@/components/windowtoaccept/particulars.vue";
export default {
    components: {
        Particulars,
    },
   props: ["valueID","indexID","markID","markrewardRecord","markpolicyMeasure","markuser","markshow","markauditStatus","filterShowdata"],
  data() {
    var validateCallTitle = (rule, value, callback) => {
      if (this.operErrors.title) {
        callback(new Error(this.operErrors.title));
      } else {
        callback();
      }
      if (this.operErrors.orderWeight) {
        callback(new Error(this.operErrors.orderWeight));
      } else {
        callback();
      }
    };
    return {
       // 重申审核状态
      markshowID:0,
      markauditStatusID:0,
      markpolicyMeasureID:0,
      markuserID:0,
      markrewardRecordID:0,
      mark:1,
      keyindex:0,
      tableHeight:400,
      size: '',
      disabled:false,
      loading:false,
      sourceType: 8,
      systemlist: [],
      lsp: [],
      permission: {
        isHaveLookPermission: false,
        isHaveCheckPermission: false,
      
      },
      dateContent:[],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
     
      //搜索
      searchForm: {
       keywords:'',
      },
      page: 1,
      pagesize: 10,
      datailtotalCount: 0,
      detailsearchForm: {
       keywords:'',
       villageID:"",
       certificateNo:'',
      },
      //进来加载数据是否展示loading圈
      showDataLoading: true,
      showDataDetailLoading:true,
      //添加-修改
      operKey: 0,
      dialogVisible:false,
      dialogFormVisible:false,
      dialogOperFormVisible: false,
      dialogdetailVisible:false,
      dialogdataFormVisible:false,
      applyaudituserlist:[],
      operbuttonloading: false,
      operbuttondisabled: false,
       villageList:[],
       p_region_id:'',
      region_level:'',
      //详情
      detailKey: 1,
      dialogDetailFormVisible: false,
      detaiForm: {
        detail: "",
      },
      checkedForm:{
          is_audit_pass: "0",
          noPassReason:'',
          noPassReasonList:[],
          noPassReasontext:'',
          apply_record_ids:'',
          user_ids:'',
          policy_measure_id:'',
      },
      rules:{

      },
      multipleSelection: [],
      childListlist:[], 
     
      // 申请记录id
      applyRecordID:0,
      policyMeasureName:'' , 
      particularstitle:'',
      certificateNo:''
     };
  },
  created: async function () {
    await this.getapplyaudit1list(
      this.pageIndex,
      this.pageSize,
      ''
    );
     this.p_region_id =  store.getters.adminRegionID
      this.region_level = parseInt(store.getters.adminRegionLevel) +1
        console.log(this.region_level)
         console.log(this.region_level === 5)
        if( this.region_level === 5){
            this.getRegionList(this.region_level,this.p_region_id)      
        }
      //  $('.el-table ').css('min-height',($(".tab-content").height()-40-$(".pageblock").outerHeight(true))+'px')
    this.tableHeight=$(".tab-content").height()-30-$(".searchcontent").outerHeight(true)-$(".pageblock").outerHeight(true)
    this.getSystemcodeinfogetlist(13)
       // $('.el-table ').css('min-height',($(".tab-content").height()-30-$(".searchcontent").outerHeight(true)-$(".pageblock").outerHeight(true))+'px')

    this.permission.isHaveLookPermission = permissionTool.isHavePermission(
      "lookapplyaudit1userlist",
      this.lsp
    );
    this.permission.isHaveCheckPermission = permissionTool.isHavePermission(
      "applybatchaudit",
      this.lsp
    );
    
  },
  mounted: function () {},
  methods: {
    initLeft(){
        return sysframe.getSideBarLeft()
    },
   //获取搜索框的 下拉框
    async getSystemcodeinfogetlist(mark) {
        await systemcodeModule
            .systemcodeinfogetlist(mark)
            .then((response) => {
                console.log(1111222,response)
            switch (response.data.code) {
                case 100:{
                    this.checkedForm.noPassReasonList = response.data.result
                }
                break;
            }
            })
            .catch((error) => {
            console.log("error", error);
        });
    },
    //获取城市列表
    async getRegionList(region_level,p_region_id) {
        await regionModule
            .regioninfogetlist(region_level,p_region_id)
            .then((response) => {
            switch (response.data.code) {
              
                case 100:{
                    let obj={
                            baseRegionID:0,
                            baseRegionName:'全部'
                        }
                  if(region_level==1){
                    this.provinceList=response.data.result
                  }else if(region_level==2){
                      this.cityList=response.data.result
                  }else if(region_level==3){
                      this.districtList=response.data.result
                  }else if(region_level==4){
                      this.countryList=response.data.result
                  }else if(region_level==5){
                      this.villageList=response.data.result
                      this.villageList.unshift(obj)
                  }
                //this.toDeal(response.data.result);
                }
                break;
                
            }
            })
            .catch((error) => {
            console.log("error", error);
            this.loading = false;
        });
    },
    async getapplyaudit1list( page, pagesize,keywords
    ) {
      this.systemlist = [];
      await applyauditModel
        .applyaudit1list( page, pagesize,keywords)
        .then((response) => {
          this.showDataLoading = false;
          if(response.data.lsp !==null){
              this.lsp=response.data.lsp
          }
          switch (response.data.code) {
            case 100:
              this.systemlist = response.data.result;
             
              this.totalCount = response.data.recordcount;
              break;
            case 101:
            this.systemlist=[]
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch((error) => {});
    },
    getRowKey(row) {
      return row.noticeID;
    },
    //更改每页显示条数
    async handleSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      await this.getapplyaudit1list(
      this.pageIndex,
      this.pageSize,
      this.searchForm.keywords
    );
    },
    //设置当前页
    async handleCurrentChange(val) {
      this.pageIndex = val;
        await this.getapplyaudit1list(
          this.pageIndex,
          this.pageSize,
          this.searchForm.keywords
        );
    },
    async onSearch() {
      this.totalCount = 0;
      this.pageIndex = 1;
      await this.getapplyaudit1list(
      this.pageIndex,
      this.pageSize,
      this.searchForm.keywords
    );
    },

    
    lookDetail(row){
          this.dialogdetailVisible = true
          this.checkedForm.policy_measure_id = row.policyMeasureID
           this.detailsearchForm.keywords = ''
          this.policyMeasureName=row.policyMeasureName
          this.particularstitle=this.policyMeasureName+'-'+'申请人列表'
          this.getapplyaudit1userlist(1,10,'',row.policyMeasureID,0,0,'') 
    },
        //详情列表
    async getapplyaudit1userlist( page, pagesize,keywords,policy_measure_id,region_level,region_id,id_number) {
      if(region_id ==''){
          region_id = 0
          region_level=0
      }
      this.applyaudituserlist = [];
      this.showDataLoading = true;
      await applyauditModel
        .applyaudit1userlist( page, pagesize,keywords,policy_measure_id,region_level,region_id,id_number)
        .then((response) => {
          this.showDataLoading = false;
          if(response.data.lsp !==null){
              this.lsp=response.data.lsp
          }
          switch (response.data.code) {
            case 100:
              this.applyaudituserlist = response.data.result;
              this.applyaudituserlist.forEach(e=>{
                    e.applyTime = publicFun.timestampToTime(e.applyTime).substring(0,10)
                    e.userBirthday = publicFun.timestampToTime(e.userBirthday).substring(0,10)
                    e.marriageChanges =  publicFun.timestampToTime(e.marriageChanges).substring(0,10)
            })
              this.datailtotalCount =  response.data.recordcount;
             
              break;
            case 101:
            this.applyaudituserlist=[]
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch((error) => {});
    },

  //更改每页显示条数
    async handledatailSizeChange(val) {
      this.pagesize = val;
      this.page = 1;
      await this.getapplyaudit1userlist(this.page,this.pagesize ,this.detailsearchForm.keywords, this.checkedForm.policy_measure_id,this.region_level,this.detailsearchForm.villageID,this.certificateNo) 
    },
    //设置当前页
    async handledatailCurrentChange(val) {
      this.page = val;
      await this.getapplyaudit1userlist(this.page,this.pagesize ,this.detailsearchForm.keywords, this.checkedForm.policy_measure_id,this.region_level,this.detailsearchForm.villageID,this.certificateNo) 
    },
    async ondetailsearchForm() {
      this.datailtotalCount = 0;
      this.page = 1;
      // this.certificateNo
      await this.getapplyaudit1userlist(this.page,this.pagesize ,this.detailsearchForm.keywords, this.checkedForm.policy_measure_id,this.region_level,this.detailsearchForm.villageID,this.certificateNo) 
    },
   //关闭添加修改弹框时重置
      clearEditList(checkedForm){
          this.$refs[checkedForm].resetFields();
          console.log("sdhkas")
        
          this.clear()
          this.$forceUpdate()
      },
      clear(){
            this.checkedForm.noPassReasontext = '' 
          this.checkedForm.noPassReason = '' 
            this.checkedForm.is_audit_pass = '0'  
      },
        


     handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      oncheckList(){
          this.dialogFormVisible = true
      },
      checked(row){
        
        this.checkedForm.apply_record_ids =`[` + row.applyRecordID.toString()+ `]`
        this.checkedForm.user_ids =`[` + row.userID.toString()+ `]`
        this.dialogFormVisible = true
      },
      oncheckSubmit(){
        if(this.checkedForm.is_audit_pass == '0'){
            if(this.checkedForm.noPassReasontext==''&& this.checkedForm.noPassReason==''){
                this.$message.error('请输入或选择不通过原因');
                    return
            }
        }
          var noPassReason = ''
        if(this.checkedForm.noPassReason==''){
               noPassReason=0
        }else{
             noPassReason=this.checkedForm.noPassReason
        }
          // var text = ''
          // if(this.checkedForm.noPassReasontext !=''){
          //     text = this.checkedForm.noPassReasontext
          // }else{
          //   text = this.checkedForm.noPassReason
          // }  
          // console.log(this.checkedForm.is_audit_pass)
          this.applybatchaudit( this.checkedForm.apply_record_ids,this.checkedForm.user_ids,this.checkedForm.policy_measure_id ,this.checkedForm.is_audit_pass,noPassReason,this.checkedForm.noPassReasontext,1 )
      },
    //申报审核
    async applybatchaudit(apply_record_ids,user_ids,policy_measure_id,is_audit_pass,no_pass_reason_id,no_pass_reason,mark) {
      await applyauditModel
        .applybatchaudit(apply_record_ids,user_ids,policy_measure_id,is_audit_pass,no_pass_reason_id,no_pass_reason,mark)
        .then((response) => {
          switch (response.data.code) {
            case 100:{
               this.dialogFormVisible = false
               
               this.getapplyaudit1userlist(this.page,this.pagesize ,this.detailsearchForm.keywords, this.checkedForm.policy_measure_id,this.region_level,this.detailsearchForm.villageID,this.certificateNo) 
                 this.getapplyaudit1list(
                  this.pageIndex,
                  this.pageSize,
                  this.searchForm.keywords
                );
                const h = this.$createElement;
                this.$notify({
                    title: "成功",
                    message: h("span", response.data.message),
                    type: "success",
                });
              }
              break;
            case 101:
            case 103:
              this.$message.error(response.data.message);
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch(function (error) {});
    },
    // 查看资料
    editFunds(row){
      this.keyindex++
      this.dialogdataFormVisible=true
      this.applyRecordID=row.applyRecordID
          //审核  
      this.markrewardRecordID=row.applyRecordID
      this.markpolicyMeasureID=this.checkedForm.policy_measure_id
      this.markuserID=row.userID
      this.markauditStatusID=0
     //展示审核
      this.markshowID=1
    },
    clearlookoverList(){
      console.log('this.markpolicyMeasureID',this.markpolicyMeasureID)
    },
    getTypedata(val){
      console.log('关闭页面事件')
      this.dialogdataFormVisible=val
      this.getapplyaudit1list(
          this.pageIndex,
          this.pageSize,
          this.searchForm.keywords
        );
      this.getapplyaudit1userlist(this.page,this.pagesize ,this.detailsearchForm.keywords, this.checkedForm.policy_measure_id,this.region_level,this.detailsearchForm.villageID,this.certificateNo) 
    }
    
  },
};
</script>

<style scoped>
    .pageblock{
        text-align: right;
        margin-top: 5px;
    }
    .tablecolumn{
        margin-left: 10px;
        margin-top: 5px;
    }
    .title{
      font-size: 16px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 10px;
    }
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    
    .clearfix:after {
        clear: both
    }

</style>